import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const Step2BusinessContact = ({ register, errors, setValue }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="form-group">
          <label className="form-label">Max. Hourly Billing Rate ($)</label>
          <input
            type="number"
            {...register("hourlyPayRate")}
            className="form-input"
            placeholder="48"
          />
          {errors.hourlyPayRate && (
            <span className="form-error">{errors.hourlyPayRate.message}</span>
          )}
        </div>

        <div className="form-group">
          <label className="form-label">Company Website URL</label>
          <input
            type="text"
            {...register("companyWebsiteUrl")}
            className="form-input"
            placeholder="https://www.amazon.com"
          />
          {errors.companyWebsiteUrl && (
            <span className="form-error">{errors.companyWebsiteUrl.message}</span>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="form-group">
          <label className="form-label">Contact Person (Facility Manager, Receptionist)</label>
          <input
            type="text"
            {...register("contactPersonName")}
            className="form-input"
            placeholder="John Smith"
          />
          {errors.contactPersonName && (
            <span className="form-error">{errors.contactPersonName.message}</span>
          )}
        </div>

        <div className="form-group">
          <label className="form-label">Email (Invoice, Enquiries)</label>
          <input
            type="email"
            {...register("contactEmail")}
            className="form-input"
            placeholder="john.doe@example.com"
          />
          {errors.contactEmail && (
            <span className="form-error">{errors.contactEmail.message}</span>
          )}
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Phone</label>
        <PhoneInput
          defaultCountry="US"
          onChange={(value) => setValue("customerContact", value)}
          className="form-input"
        />
        {errors.customerContact && (
          <span className="form-error">{errors.customerContact.message}</span>
        )}
      </div>
    </div>
  );
};

export default Step2BusinessContact;
